import React, { Component } from "react";
import { Card, CardBody, InputGroup, Col, Form, Row } from "reactstrap";
import Flatpickr from "react-flatpickr";
import styled from "styled-components";
import PropTypes from "prop-types";
import DefaultMultipleSelect from "../DefaultMultipleSelect/DefaultMultipleSelect";
import { getCurrentDay, getSelectedDaysAgo } from "../../helpers/utils";

class FormToFilterReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: null,
      ad_ids: null,
      campaign_ids: null,
      campaign_names: null,
    };
  }

  componentDidMount() {
    const { selectedDate } = this.props;
    this.setState({
      date: `${selectedDate.start_date} to ${selectedDate.end_date}`,
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        ad_ids: this.props.data.ad_ids,
        campaign_ids: this.props.data.ad_ids,
        campaign_names: this.props.data.campaign_names,
      });
    }
  }

  handleSelectCampId = (_, status, data) => {
    const { campaign_ids } = this.state;
  };

  handleSelectCampName = (_, status, data) => {
    const { campaign_names } = this.state;
  };

  onFiltersChange = date => {
    this.setState({ date });
    const data = {
      start_date: date.split(" ")[0],
      end_date: date.split(" ")[2] || getCurrentDay(),
    };

    if (date.split(" ")[2] !== undefined) {
      this.props.onFiltersChange(data);
    }
  };

  handleSelectedOffers = (_, status, data) => {
    const { offerTypes } = this.state;
    let dt = offerTypes.concat([]);

    for (let i in dt) {
      dt[i].checked = data.find(x => x.value == dt[i].id) !== undefined;
    }

    this.setState({
      offerTypes: dt,
    });

    this.handleFiltering();
  };

  render() {
    return (
      <StyledRow>
        <Col className="col-12">
          <StyledCard>
            <CardBody>
              <Row className="justify-content-between">
                <Col xl={9} className="mb-1">
                  <Form className="row gy-2 gx-3 align-items-center">
                    <div className="col-sm-auto">
                      <span>Filter by: </span>
                    </div>
                    <div className="col-sm-auto">
                      <DefaultMultipleSelect
                        options={
                          this.state.campaign_ids?.length > 0
                            ? this.state.campaign_ids.map((i, idx) => ({
                                key: idx,
                                text: i,
                                checked: false,
                              }))
                            : []
                        }
                        search
                        onChange={this.handleSelectCampId}
                        plug="Campaign ID"
                      />
                    </div>
                    <div className="col-sm-auto">
                      <DefaultMultipleSelect
                        options={
                          this.state.campaign_names?.length > 0
                            ? this.state.campaign_names.map((i, idx) => ({
                                key: idx,
                                text: i,
                                checked: false,
                              }))
                            : []
                        }
                        search
                        onChange={this.handleSelectCampName}
                        plug="Campaign name"
                      />
                    </div>
                  </Form>
                </Col>
                <Col sm={3}>
                  <Form className="row gy-2 gx-3 align-items-center">
                    <div className="col-xl">
                      <div
                        style={{
                          display: "flex",
                          verticalAlign: "middle",
                          flexWrap: "wrap",
                          alignItems: "center",
                          float: "right",
                        }}
                      >
                        <div>
                          <span style={{ marginRight: "15px" }}>
                            Date range:
                          </span>
                        </div>
                        <div>
                          <PickerStyled>
                            <Flatpickr
                              name="test"
                              value={this.state.date}
                              className="form-control d-block"
                              placeholder="Select date range..."
                              options={{
                                mode: "range",
                                dateFormat: "Y-m-d",
                              }}
                              onChange={(date, dateStr) =>
                                this.onFiltersChange(dateStr)
                              }
                            />
                          </PickerStyled>
                        </div>
                      </div>
                    </div>
                  </Form>
                </Col>
              </Row>
            </CardBody>
          </StyledCard>
        </Col>
      </StyledRow>
    );
  }
}

const StyledRow = styled.div`
  padding: 0;
  margin: 0;
  z-index: 4;
  position: sticky;
  top: 69px;
  /* box-shadow: -100px 0px 0px 0px #f8f8fb, 100px 0px 0px 0px #f8f8fb,
    0px 2px 0px 0px #f0f0f0; */
`;

const StyledCard = styled(Card)`
  box-shadow: none !important;
  background: #f8f8fb;
  border-radius: 0.1px;
`;

const PickerStyled = styled(InputGroup)`
  max-width: 180px;

  input {
    background: #fff !important;
  }
`;

FormToFilterReport.propTypes = {
  onFiltersChange: PropTypes.func.isRequired,
  data: PropTypes.any,
  selectedDate: PropTypes.any,
};

export default FormToFilterReport;
